import React, { useCallback } from "react";
import { FormControl, FormHelperText, Grid, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";

interface FieldReferralProps {
    value: HallReferral;
    setValue: (referral: HallReferral) => void;
}

const FieldReferral: React.FC<FieldReferralProps> = ({ value, setValue: setReferral }) => {
    const [t] = useTranslation();
    const onChangePercent = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const textValue = e.target.value.trim();
        if (textValue.match(/^\d+$/)) {
            setReferral({ ...value, percent: +textValue });
        }
    }, [setReferral, value]);

    const onChangeWager = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const textValue = e.target.value.trim();
        if (textValue.match(/^\d+$/)) {
            setReferral({ ...value, wager: +textValue });
        }
    }, [setReferral, value]);

    const onChangePeriod = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        const textValue = e.target.value.trim();
        if (textValue.match(/^\d+$/)) {
            setReferral({ ...value, period: 60 * +textValue });
        }
    }, [setReferral, value]);

    return <>
        <h2>{t("ru.halls.wager.referral.title")}</h2>
        <Grid item xs={12} sm={12}>
            <FormControl fullWidth size="small">
                <TextField type="number" name="referral_percent" value={value.percent ?? 0} onChange={onChangePercent} size="small" />
                <FormHelperText> {t("ru.halls.wager.referral.percent")} </FormHelperText>
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={12}>
            <FormControl fullWidth size="small">
                <TextField type="number" name="referral_period" value={(value.period ?? 0) / 60} onChange={onChangePeriod} size="small" />
                <FormHelperText> {t("ru.halls.wager.referral.period")} </FormHelperText>
            </FormControl>
        </Grid>
        <Grid item xs={12} sm={12}>
            <FormControl fullWidth size="small">
                <TextField type="number" name="referral_wager" value={value.wager ?? 0} onChange={onChangeWager} size="small" />
                <FormHelperText> {t("ru.halls.wager.referral.wager")} </FormHelperText>
            </FormControl>
        </Grid>
    </>;
}

export default FieldReferral;
